export default "__VITE_ASSET__OSNq8rXU__"